import { alpha, MenuItem, Typography, useTheme } from "@mui/material";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { AppType } from "src/types/apps";

import Context from "../context";

// ----------------------------------------------------------------------

type Props = {
	app: AppType;
};

export default function AppMenuItem({ app }: Props) {
	const { actions } = useContext(Context);
	const { translate } = useLocales();
	const theme = useTheme();

	const queryClient = useQueryClient();
	const { data: appSelected } = useQuery<string>({
		queryKey: ["apps", "selected"]
	});

	const isSelected = app.id === appSelected;

	const onClick = () => {
		queryClient.setQueryData(["apps", "selected"], app.id);
		actions.hideSelectAppMenu();
	};

	return (
		<MenuItem
			key={app.id}
			onClick={onClick}
			sx={{
				backgroundColor: isSelected ? alpha(theme.palette.primary.light, 0.16) : "background.paper",
				borderRadius: 0.5
			}}
		>
			<Typography variant='body2' color={isSelected ? "primary.main" : "text.primary"}>
				{translate(app.name)}
			</Typography>
		</MenuItem>
	);
}
